<ng-container *ngIf="menuOperation$ | async as operation" [xOperation]="operation">
  <div class="main-menu" *xOperationLoading>
    <nav class="nav-loading">
      <x-loader size="small" [dots]="7" loader="dot-flashing"></x-loader>
    </nav>
  </div>
  <div *xOperationResult class="main-menu" (mouseleave)="onMainMenuLeave()">
    <nav>
      <div mat-tab-nav-bar [tabPanel]="tabPanel" mat-stretch-tabs="false">
        <a
          mat-tab-link
          *ngFor="let node of nodes$ | async as nodes; trackBy: 'id' | trackBy"
          (mouseenter)="onTabEnter(node)"
          [active]="!!(topLevelActiveNode$ | async)?.includes(node.id)"
          [routerLink]="node.url"
          (click)="setActive(node)"
          class="mat-subtitle-2"
        >
          {{ node.name }}
        </a>
      </div>
      <div class="nav-actions" (mouseenter)="onMainMenuLeave()">
        <x-search-button></x-search-button>
        <button
          mat-icon-button
          i18n-matTooltip="@@NavActions.Favourites"
          matTooltip="Go to Favourites"
          matTooltipClass="accent"
          routerLink="./my-account/favourites"
        >
          <fa-icon icon="heart-broken"></fa-icon>
        </button>
        <button
          mat-icon-button
          i18n-matTooltip="@@NeedHelp.NeedAssistance"
          matTooltip="Need Assistance"
          matTooltipClass="accent"
          xNeedHelp
        >
          <fa-icon icon="question"></fa-icon>
        </button>
      </div>
    </nav>
    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
    <ng-container *ngIf="subMenu$ | async as subMenu">
      <div class="sub-menu-wrap" *ngIf="subMenu.children" [@menuInOut]>
        <div class="container">
          <ng-container
            *ngTemplateOutlet="nodeTemplate; context: { $implicit: subMenu.children }"
          ></ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>

<!--node template-->
<ng-template #nodeTemplate let-nodes>
  <ng-container *ngIf="nodes && nodes.length > 0 && nodes[0].depth <= 3">
    <ul class="sub-menu" [@fadeInOut]>
      <li *ngFor="let node of nodes; trackBy: 'id' | trackBy">
        <a [routerLink]="[node.url]" [class.active]="(activeNodeIds$ | async)?.includes(node.id)">
          <ng-container *ngIf="node.media">
            <x-media-thumbnail
              [url]="node.media?.url"
              width="230"
              height="100"
              class="mb-1"
            ></x-media-thumbnail>
          </ng-container>

          <span>
            {{ node.name }}
          </span>
        </a>
        <ng-container
          *ngTemplateOutlet="nodeTemplate; context: { $implicit: node.children }"
        ></ng-container>
      </li>
    </ul>
  </ng-container>
</ng-template>
